<app-personal-data></app-personal-data>

<app-acceptation-form (isReady)="onReady($event)" [language]="language"></app-acceptation-form>

<div class="loading-spinner-kala" *ngIf="loading"></div>
